import React from 'react';
import './LoadingSpinner.css';

/**
 * Global LoadingSpinner — muestra el timón animado (helm.gif) mientras
 * se cargan datos. Reemplaza el patrón <div className="loading-spinner">.
 *
 * Props:
 *  label   — texto que aparece bajo el ícono (opcional)
 *  height  — altura mínima del contenedor (default "200px")
 *  style   — estilos inline adicionales para el wrapper
 */
const LoadingSpinner = ({ label = '', height = '200px', style = {} }) => (
  <div
    className="helm-loader-wrapper"
    style={{ minHeight: height, ...style }}
  >
    <img
      src="/icons/helm.gif"
      alt="Cargando…"
      className="helm-loader-icon"
    />
    {label && <p className="helm-loader-label">{label}</p>}
  </div>
);

export default LoadingSpinner;
